import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import MasterComponent from '../../common/MasterComponent';
import { Stack, Tab, Tabs, Tooltip, Typography, useTheme } from '@mui/material';
import UseCasePopup from './addEditPopup';
import { pageActions } from '../../store/reducers/page-actions';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { get } from 'lodash';
import { useCaseFormType } from './form';
import PopUp from '../../components/Popup';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/main/info-icon.svg';
import { useCaseBuilderActions } from '../../store/reducers/usecase-management';
import { GridValueGetterParams } from '@mui/x-data-grid';
import Chip from '@mui/material/Chip';
import { sentenceCase } from 'change-case';
import Snackbar from '../../common/snackBar';
import dayjs from 'dayjs';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { connectivityDashboardActions } from '../../store/reducers/connectivity-dashboard';
import UseCaseAccessPopup from './UseCaseAccessPopup';
import { userRoleActions } from '../../store/reducers/user-role';
import TemplatePreview from './templatePreview';

const UseCaseBuilder = ({
    ontologyData,
    useCaseData,
    isAddUseCaseSuccess,
    isUpdateUseCaseSuccess,
    isRemoveUseCaseSuccess,
    searchItem,
    useCaseDataPageNumber,
    useCaseDataTotalRowCount,
    isAddCustomJsonTemplateSuccess,
    isUpdateCustomJsonTemplateSuccess,
    isDeleteCustomJsonTemplateSuccess,
    customJsonTemplateTotalRowCount,
    customJsonTemplatePageNumber,
    isApproveUseCaseSuccess,
    isUseCaseDataLoading,
    customJsonTemplates,
    assets,
    userRole,
    isUserRoleLoading,
    grafanaTemplateData,
    assetPropertiesData,
    assetsPropertiesLoading,
    isOntologyDataLoading,
    assetsLoading,
    ontologyDataHasError,
    assetsRequestFailed,
    assetsPropertiesRequestFailed,
    isGrafanaTemplateLoading,
    isGrafanaTemplateError,
    isForcedDelete
}: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const themeData: any = useTheme();
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
    const [popupData, setPopupData] = useState<any>(null); // Data for add/edit
    const [confirmPopup, setConfirmPopup] = useState<boolean>(false); // Tracks the state of the delete confirmation popup
    const [deleteItem, setDeleteItem] = useState<any>(null); // Tracks the item to be deleted
    const { pathname } = useLocation();
    const [hiddenColumns, setHiddenColumns] = useState<any>({});
    // Parameters for search, sort, and pagination
    const [searchText, setSearchText] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [sortModel, setSortModel] = useState<any[]>([]);
    const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
    const [selectedRows, setSelectedRows] = useState<any>([]);
    const [isAccessPopupOpen, setIsAccessPopupOpen] = useState<boolean>(false); // State to manage access popup visibility
    const [selectedUseCase, setSelectedUseCase] = useState<any>(null); // State to track the selected use case for access
    const [accessOptions] = useState<string[]>(['Read', 'Write', 'Execute']); // Example access options
    const [isRolesLoading, setIsRolesLoading] = useState<boolean>(false);
    const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);
    const [useCasePreviewData, setUseCasePreviewData] = useState<any>(null);
    const payload: any = {
        limit: DEFAULT_PAGE_SIZE,
        page: DEFAULT_PAGE_NUMBER,
        filter_status: selectedTab === 0 ? 'list' : selectedTab === 1 ? 'custom_template' : 'waiting_for_approval',
    }

    const dispatchUseCaseBuilderListRequest = (payload: any) => {
        selectedTab === 0 || selectedTab === 2 ? dispatch(useCaseBuilderActions.getUseCaseDataRequest({ ...sortingModel, search_item: searchItem, ...payload })) : dispatch(useCaseBuilderActions.getCustomJsonTemplatesRequest({ ...sortingModel, search_item: searchItem, ...payload }));
    };

    useEffect(() => {
        dispatch(ontologyMasterActions.getOntologyList(''));
        dispatch(ontologyMasterActions.getOntologyMgmntList(''));
        dispatch(
            connectivityDashboardActions.getAssetsRequest({
                onto_manage_id: 0,
                timestamp: new Date().getTime(),
                search_item: '',
                filter_by: '',
                field: '',
                sort: ''
            })
        );
        dispatch(connectivityDashboardActions.getAssetPropertiesDataRequest());
    }, []);

    useEffect(() => {
        if ((pathname.split('/')).includes('grafana-templates')) {
            setHiddenColumns({});
            setSelectedTab(1);
            dispatch(useCaseBuilderActions.getCustomJsonTemplatesRequest(payload));
        } else if ((pathname.split('/')).includes('pending-approval')) {
            setHiddenColumns({});
            setSelectedTab(2);
            let pendingPayload: any = { ...payload, filter_status: 'waiting_for_approval' }
            dispatch(useCaseBuilderActions.getGrafanaTemplatesRequest());
            dispatch(useCaseBuilderActions.getUseCaseDataRequest(pendingPayload));
        } else {
            setHiddenColumns({});
            setSelectedTab(0);
            dispatch(useCaseBuilderActions.getGrafanaTemplatesRequest());
            const reqpayload: any = { ...payload, filter_status: 'list' };
            dispatch(useCaseBuilderActions.getUseCaseDataRequest(reqpayload));
        }
    }, [pathname]);

    useEffect(() => {
        if (isAddUseCaseSuccess || isUpdateUseCaseSuccess || isRemoveUseCaseSuccess || isApproveUseCaseSuccess) {
            if (isRemoveUseCaseSuccess) {               
                setDeleteItem(null);
            }
             if (isForcedDelete) { dispatch(useCaseBuilderActions.clearForcedDelete()) }
            dispatch(useCaseBuilderActions.getUseCaseDataRequest(payload));
            setSelectedRows([]);
            dispatchUseCaseBuilderListRequest({
                limit: DEFAULT_PAGE_SIZE,
                page:
                    isRemoveUseCaseSuccess && useCaseData.length === 1 && useCaseDataPageNumber !== 1
                        ? useCaseDataPageNumber - 1
                        : useCaseDataPageNumber,
                filter_status: selectedTab === 0 ? 'list' : selectedTab === 1 ? 'custom_template' : 'waiting_for_approval',
            });
        }

        if (isAddCustomJsonTemplateSuccess || isUpdateCustomJsonTemplateSuccess || isDeleteCustomJsonTemplateSuccess) {
            if (isDeleteCustomJsonTemplateSuccess) {
                setDeleteItem(null);
            }
             if (isForcedDelete) { dispatch(useCaseBuilderActions.clearForcedDelete()) }
            dispatch(useCaseBuilderActions.getUseCaseDataRequest(payload));
            setSelectedRows([]);
            dispatchUseCaseBuilderListRequest({
                limit: DEFAULT_PAGE_SIZE,
                page:
                    isDeleteCustomJsonTemplateSuccess && useCaseData.length === 1 && customJsonTemplatePageNumber !== 1
                        ? customJsonTemplatePageNumber - 1
                        : customJsonTemplatePageNumber,
                filter_status: selectedTab === 0 ? 'list' : selectedTab === 1 ? 'custom_template' : 'waiting_for_approval',
            });
        }
    }, [isAddUseCaseSuccess, isUpdateUseCaseSuccess, isRemoveUseCaseSuccess, isAddCustomJsonTemplateSuccess, isUpdateCustomJsonTemplateSuccess, isDeleteCustomJsonTemplateSuccess, isApproveUseCaseSuccess])

    useEffect(() => {
        // Fetch data whenever search, sort, or pagination changes
        fetchData();
    }, [searchText, page, pageSize, sortModel]);

    const fetchData = () => {
        const params = {
            search: searchText,
            page,
            pageSize,
            sort: sortModel.map((sort) => `${sort.field}:${sort.sort}`).join(','),
        };
        // Uncomment the following dispatch to fetch data
        // dispatch(fetchUseCaseData(params));        
    };

    const handleTabChange = (e: any, value: number) => {
        setSelectedTab(value);
        if (value === 0) {
            setHiddenColumns({});
            navigate('/usecase-management');
        } else if (value === 1) {
            setHiddenColumns({});
            navigate('/usecase-management/grafana-templates');
        } else {
            setHiddenColumns({ actions: false });
            navigate('/usecase-management/pending-approval');
        }
        const s: any = ''
        dispatch(useCaseBuilderActions.onSearchForItem(s));
    };

    const handleAddClick = () => {
        if (selectedTab === 1) {
            dispatch(useCaseBuilderActions.getGrafanaTemplatesRequest());
        }
        setPopupData(null); // Clear data for "Add" operation
        setIsPopupOpen(true);
    };

    const handleEditClick = (rowData: any) => {
        if (selectedTab === 1) {
            dispatch(useCaseBuilderActions.getGrafanaTemplatesRequest());
        }
        let data: any = get(rowData, 'row', {});
        data = { ...data, navigation_icon: data?.navigation_icon ? JSON.parse(data?.navigation_icon) : null }
        setPopupData({ ...data, mode: 'edit' }); // Set data for "Edit" operation
        setIsPopupOpen(true);
    };

    const handleViewClick = (rowData: any) => {
        let data: any = get(rowData, 'row', {});
        data = { ...data, navigation_icon: data?.navigation_icon ? JSON.parse(data?.navigation_icon) : null }
        setPopupData({ ...data, mode: 'view' });

        setIsPopupOpen(true);
    };

    const handleDeleteClick = (rowData: any) => {
        setDeleteItem(rowData); // Set the item to be deleted
        setConfirmPopup(true); // Open the delete confirmation popup
    };

    const handlePopupClose = () => {
        setIsPopupOpen(false);
        setPopupData(null);
    };

    const handlePopupSubmit = (formData: any) => {
        if (selectedTab === 0) {
            if (popupData?.mode === 'edit') {
                const editPayload: any = [formData]
                let statusPayload: any = { status: 'update', payload: editPayload };
                dispatch(useCaseBuilderActions.updateUseCaseRequest(statusPayload));
            } else {
                dispatch(useCaseBuilderActions.addUseCaseRequest(formData));
            }
        } else {
            if (popupData?.mode === 'edit') {
                const editPayload: any = formData
                dispatch(useCaseBuilderActions.updateCustomJsonTemplateRequest(editPayload));
            } else {
                dispatch(useCaseBuilderActions.addCustomJsonTemplateRequest(formData));
            }
        }

        setIsPopupOpen(false);
        setPopupData(null);
    };

    const handleDeleteConfirm = () => {
        if (selectedTab === 0) {
            const deletePayload: any = { ...deleteItem, forced_delete: isForcedDelete };
            dispatch(useCaseBuilderActions.removeUseCaseRequest(deletePayload));
        } else {
            const deletePayload: any = { ...deleteItem, forced_delete: isForcedDelete };
            dispatch(useCaseBuilderActions.deleteCustomJsonTemplateRequest(deletePayload));
        }

        setConfirmPopup(false); // Close the confirmation popup
        // setDeleteItem(null); // Clear the delete item
    };

    const handleDeleteCancel = () => {
        setConfirmPopup(false); // Close the confirmation popup
        setDeleteItem(null); // Clear the delete item
        dispatch(useCaseBuilderActions.clearForcedDelete());
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
    };

    const handleSortChange = (newSortModel: any[]) => {
        setSortModel(newSortModel);
    };

    const handleRowSelection = (params: any) => {
        setSelectedRows(params);
    };

    const onStatusChange = (statusType: string) => {
        if (selectedRows.length) {
            const payload: any = useCaseData
                .filter((item: any) => selectedRows.includes(item.use_case_id))
                .map((item: any) => {
                    if (statusType != '') {
                        // return { ...item, status: statusType };
                        if (statusType === 'approved' || statusType === 'rejected') {
                            return {
                                use_case_id: item.use_case_id,
                                use_case_name: item.use_case_name,
                                status: statusType
                            }
                        } else {
                            return { ...item, status: statusType };
                        }
                    } else {
                        return { ...item };
                    }
                });
            if (statusType === 'approved') {
                let statusPayload: any = { status: statusType, payload: payload };
                dispatch(useCaseBuilderActions.approveUseCaseRequest(statusPayload));
            } else if (statusType === 'waiting_for_approval') {
                let statusPayload: any = { status: statusType, payload: payload };
                dispatch(useCaseBuilderActions.updateUseCaseRequest(statusPayload));
            } else if (statusType === 'rejected') {
                let statusPayload: any = { status: statusType, payload: payload };
                dispatch(useCaseBuilderActions.approveUseCaseRequest(statusPayload));
            }
        } else {
            Snackbar.info('Please select Use case.');
        }
    };

    const isRowSelectable = (params: any) => {
        return !['approved', 'rejected', 'deployed'].includes(params.row.status);
    };

    // Open the access popup
    const handleAccessClick = (useCase: any) => {
        setSelectedUseCase(useCase);
        setIsRolesLoading(true);
        const payload: any = { role_table: true };
        dispatch(userRoleActions.getRoleList(payload));
    };

    useEffect(() => {
        if (isRolesLoading && !isUserRoleLoading && userRole && userRole.length > 0) {
            setIsAccessPopupOpen(true);
            setIsRolesLoading(false);
        }
    }, [isUserRoleLoading, userRole, isRolesLoading]);

    const handleAccessClose = () => {
        setSelectedUseCase({});
        setIsAccessPopupOpen(false);
    };

    const handleAccessSubmit = (selectedAccess: any, usecase: any) => {
        const useCaseId = usecase?.row?.use_case_id;
        // const hasRoles = Array.isArray(selectedAccess.roles) && selectedAccess.roles.length > 0;
        // const hasUsers = Array.isArray(selectedAccess.users) && selectedAccess.users.length > 0;
        // && (hasRoles || hasUsers)
        if (useCaseId) {
            const editPayload: any = [{
                use_case_id: useCaseId,
                user_access_config: selectedAccess
            }];
            let statusPayload: any = { status: 'update_access', payload: editPayload };
            dispatch(useCaseBuilderActions.updateUseCaseAccessRequest(statusPayload));
        } else {
            Snackbar.info('Please select at least one role or one user.');
        }
    };

    const handlePreviewOpen = (useCaseTemplate: any) => {
        setIsPreviewOpen(true);
        setUseCasePreviewData(useCaseTemplate?.row);
    }

    const handlePreviewClose = () => {
        setIsPreviewOpen(false);
        setUseCasePreviewData(null);
    }

    const handleDataReload = (type: 'template' | 'ontology' | 'assetsmapping' | 'assets') => {
        switch (type) {
            case 'template':
                dispatch(useCaseBuilderActions.getGrafanaTemplatesRequest());
                break;
            case 'ontology':
                dispatch(ontologyMasterActions.getOntologyList(''));
                dispatch(connectivityDashboardActions.getAssetsRequest({
                    onto_manage_id: 0,
                    timestamp: Date.now(),
                    search_item: '',
                    filter_by: '',
                    field: '',
                    sort: ''
                }));
                break;
            case 'assets':
                dispatch(connectivityDashboardActions.getAssetsRequest({
                    onto_manage_id: 0,
                    timestamp: Date.now(),
                    search_item: '',
                    filter_by: '',
                    field: '',
                    sort: ''
                }));
                break;
            case 'assetsmapping':
                dispatch(connectivityDashboardActions.getAssetPropertiesDataRequest());
                break;
            default:
                // Optionally handle unknown types
                break;
        }
    };

    const actionsColumn: any =
        selectedTab === 0 ? {
            visible: {
                onClick: handleViewClick, // View action
            },
            edit: {
                onClick: handleEditClick, // Edit action
            },
            delete: {
                onClick: handleDeleteClick, // Delete action
            },
            access: {
                onClick: handleAccessClick, // Delete action
            }
        }
            :
            selectedTab === 1
                ? {
                    visible: {
                        onClick: handleViewClick, // View action
                    },
                    edit: {
                        onClick: handleEditClick, // Edit action
                    },
                    delete: {
                        onClick: handleDeleteClick, // Delete action
                    },
                    access: {
                        onClick: handleAccessClick, // Delete action
                    },
                    preview: {
                        onClick: handlePreviewOpen, // Delete action
                    },
                } : selectedTab === 2 ? {
                    visible: {
                        onClick: handleViewClick, // View action
                    },
                    // access: {
                    //     onClick: handleAccessClick, // Delete action
                    // },
                } : {}

    useEffect(() => {
        if (isForcedDelete) {
            setConfirmPopup(true)
        }
    }, [isForcedDelete])
    return (
        <>
            <MasterComponent
                hiddenColumns={hiddenColumns}
                heading={
                    <Tabs
                        value={selectedTab}
                        onChange={handleTabChange}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: themeData.palette.primary.main,
                            },
                        }}
                    >
                        <Tab label="Use Cases" />
                        <Tab label="Grafana Templates" />
                        <Tab label="Pending Approval" />
                    </Tabs>
                }
                setIsModalOpen={handleAddClick}
                onRowSelectionChange={handleRowSelection}
                isFromUseCase={selectedTab === 0 || selectedTab === 2 ? true : false}
                isFromBuilder={selectedTab === 1 ? true : false}
                isFromGrfanaTemplate={selectedTab === 1 ? true : false}
                checkboxSelection={selectedTab === 0 || selectedTab === 2 ? true : false}
                selectedTab={selectedTab}
                useCaseBuilerAccess={selectedTab === 0 ? true : false} //|| selectedTab === 2 
                onStatusChange={onStatusChange}
                rows={selectedTab === 0 ? useCaseData : selectedTab === 2 ? useCaseData : customJsonTemplates}
                columns={selectedTab === 0 ? [
                    { field: 'use_case_name', headerName: 'Use Case Name', flex: 1, width: 200 },
                    { field: 'use_case_type', headerName: 'Use Case Type', flex: 1, width: 200, renderCell: (params: any) => { return useCaseFormType[params.value] || params.value; } },
                    { field: 'navigation_name', headerName: 'Navigation Name', flex: 1, width: 200 },
                    {
                        field: 'created_date', headerName: 'Created/Updated Date', flex: 1, width: 150, renderCell: (params: any) => {
                            const _created_date = (params.value && params.value !== '') ? dayjs.utc(params.value).local().format('MMM D, YYYY hh:mm A') : 'N/A';
                            return (
                                <Tooltip title={_created_date} arrow>
                                    <Typography component='p' sx={{
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                    }}>
                                        {_created_date}
                                    </Typography>
                                </Tooltip>
                            );
                        },
                    },
                    {
                        field: 'status',
                        headerName: 'STATUS',
                        headerAlign: 'left',
                        align: 'left',
                        resizable: false,
                        flex: 1,
                        minWidth: 180,
                        renderCell: (params: GridValueGetterParams) => {
                            return (
                                <><Chip label={sentenceCase(params.value ?? '')} key={params.id} className={params.value} variant='outlined' sx={{ padding: '0px 8px 0px 8px!important', width: 'auto' }} />
                                    {params.value == 'failed' && <Tooltip title={get(params.row, 'grafana_status.message', '')} arrow>
                                        <InfoIcon style={{ marginLeft: '16px', cursor: 'pointer' }} />
                                    </Tooltip>}
                                </>);
                            // minWidth: '200px' 
                        },
                    }
                ] : selectedTab === 1 ? [
                    { field: 'template_name', headerName: 'Template Name', flex: 1, width: 200 },
                    // { field: 'createdBy', headerName: 'Created By', flex: 1, width: 150 },
                    {
                        field: 'created_date', headerName: 'Created Date', flex: 1, width: 150, renderCell: (params: any) => {
                            const _created_date = (params.value && params.value !== '') ? dayjs.utc(params.value).local().format('MMM D, YYYY hh:mm A') : 'N/A';
                            return (
                                <Tooltip title={_created_date} arrow>
                                    <Typography component='p' sx={{
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                    }}>
                                        {_created_date}
                                    </Typography>
                                </Tooltip>
                            );
                        },
                    },
                ] : [
                    { field: 'use_case_name', headerName: 'Use Case Name', flex: 1, width: 200 },
                    { field: 'use_case_type', headerName: 'Use Case Type', flex: 1, width: 200, renderCell: (params: any) => { return useCaseFormType[params.value] || params.value; } },
                    { field: 'navigation_name', headerName: 'Navigation Name', flex: 1, width: 200 },
                    {
                        field: 'created_date', headerName: 'Created/Updated Date', flex: 1, width: 150, renderCell: (params: any) => {
                            const _created_date = (params.value && params.value !== '') ? dayjs.utc(params.value).local().format('MMM D, YYYY hh:mm A') : 'N/A';
                            return (
                                <Tooltip title={_created_date} arrow>
                                    <Typography component='p' sx={{
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                    }}>
                                        {_created_date}
                                    </Typography>
                                </Tooltip>
                            );
                        },
                    },
                    {
                        field: 'status',
                        headerName: 'STATUS',
                        headerAlign: 'left',
                        align: 'left',
                        resizable: false,
                        flex: 1,
                        minWidth: 200,
                        renderCell: (params: GridValueGetterParams) => { return (<Chip label={sentenceCase(params.value ?? '')} key={params.id} className={params.value} variant='outlined' sx={{ padding: '0px 8px 0px 8px!important', width: 'auto' }} />); },
                        // minWidth: '200px' 
                    }
                ]}
                otherProps={{
                    getRowId: (row: any) => {
                        return selectedTab === 0 || selectedTab === 2 ? row.use_case_id : row.template_id
                    },
                }}
                isServerPagination
                isLoading={isUseCaseDataLoading || isUserRoleLoading}
                totalRowCount={selectedTab === 1 ? customJsonTemplateTotalRowCount : useCaseDataTotalRowCount}
                pageNumber={selectedTab === 1 ? customJsonTemplatePageNumber : useCaseDataPageNumber}
                showSearch
                searchPlaceholder={`${selectedTab === 0 ? 'Name / Type / Status' : selectedTab === 1 ? 'Template Name' : 'Name / Type / Status'}`}
                searchValue={searchText}
                onSearchChange={handleSearchChange}
                page={page}
                pageSize={pageSize}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                sortModel={sortModel}
                onPagination={(pageSize: number, pageNumber: number) => {
                    dispatchUseCaseBuilderListRequest({
                        limit: pageSize,
                        page: pageNumber,
                        filter_status: selectedTab === 0 ? 'list' : selectedTab === 1 ? 'custom_template' : 'waiting_for_approval',
                    });
                }}
                onSorting={(sortModel: { field: string; sort: string }) => {
                    dispatchUseCaseBuilderListRequest({
                        limit: DEFAULT_PAGE_SIZE,
                        page: selectedTab === 1 ? customJsonTemplatePageNumber : useCaseDataPageNumber,
                        filter_status: selectedTab === 0 ? 'list' : selectedTab === 1 ? 'custom_template' : 'waiting_for_approval',
                        ...sortModel,
                    });
                    setSortingModel(sortModel);
                }}
                disableRowSelectionOnClick
                selectionModel={selectedRows}
                isRowSelectable={isRowSelectable}
                onSortModelChange={handleSortChange}
                actionsColumn={actionsColumn}
                noRowsOverlay={() => (
                    <Stack height='100%' alignItems='center' justifyContent='center'>
                       {selectedTab===0 ? 'Use case data' : 'Grafana templates' } not available
                    </Stack>
                )}
                onSearch={(searchValue: any) => {
                    dispatchUseCaseBuilderListRequest({
                        limit: DEFAULT_PAGE_SIZE,
                        page: DEFAULT_PAGE_NUMBER, //useCaseDataPageNumber
                        filter_status: selectedTab === 0 ? 'list' : selectedTab === 1 ? 'custom_template' : 'waiting_for_approval',
                        search_item: searchValue,
                    });
                    dispatch(useCaseBuilderActions.onSearchForItem(searchValue));
                }}
            />


            {/* UseCasePopup for Add/Edit */}
            <UseCasePopup
                isOpen={isPopupOpen}
                onClose={handlePopupClose}
                onSubmit={handlePopupSubmit}
                isEdit={!!popupData}
                initialData={popupData}
                data={popupData}
                // selectedTab={selectedTab}
                selectedTab={selectedTab == 0 || selectedTab == 2 ? 0 : 1}
                ontologyData={ontologyData}
                templateData={grafanaTemplateData}
                useCaseData={useCaseData}
                assets={assets || []}
                assetPropertiesData={assetPropertiesData}
                assetsPropertiesLoading={assetsPropertiesLoading}
                isOntologyDataLoading={isOntologyDataLoading}
                assetsLoading={assetsLoading}
                ontologyDataHasError={ontologyDataHasError}
                assetsRequestFailed={assetsRequestFailed}
                assetsPropertiesRequestFailed={assetsPropertiesRequestFailed}
                isGrafanaTemplateLoading={isGrafanaTemplateLoading}
                isGrafanaTemplateError={isGrafanaTemplateError}
                handleDataReload={handleDataReload}
            />

            <UseCaseAccessPopup
                isOpen={isAccessPopupOpen}
                onClose={handleAccessClose}
                onSubmit={handleAccessSubmit}
                selectedUseCase={selectedUseCase}
                rolesData={userRole}
                initialSelectedRoles={get(selectedUseCase, 'row.user_access_config.roles', []) || []} // Pre-select Admin role
                initialSelectedUsers={get(selectedUseCase, 'row.user_access_config.users', []) || []} // Pre-select Alice
            />

            <TemplatePreview
                isOpen={isPreviewOpen}
                handleClose={handlePreviewClose}
                useCasePreviewData={useCasePreviewData}
            />

            {/* Delete Confirmation Popup */}
            <PopUp
                open={confirmPopup}
                icon={<AlertIcon color={themeData.palette.warning.main} />}
                message={isForcedDelete ? `The associated grafana resource could not be found. Would you like to proceed with a force delete?` : `Are you sure to delete this ${selectedTab === 0 ? 'use case' : 'grafana template'}?`}
                cancel={true}
                confirmation={true}
                cancelLabel="No"
                confirmLabel="Yes"
                onConfirm={handleDeleteConfirm} // Call delete confirm handler
                onClose={handleDeleteCancel} // Close popup on cancel or close
                onCancel={handleDeleteCancel} // Close popup on cancel
            />
        </>
    );
};

const mapStateToProps = (state: any) => ({
    ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
    ontologyData: state.ontologyMaster.ontologyData,
    isOntologyDataLoading: state.ontologyMaster.isOntologyDataLoading,
    ontologyDataHasError: state.ontologyMaster.ontologyDataHasError,
    isUseCaseDataLoading: state.useCaseBuilder.isUseCaseDataLoading,
    useCaseData: state.useCaseBuilder.useCaseData,
    isAddUseCaseSuccess: state.useCaseBuilder.isAddUseCaseSuccess,
    isUpdateUseCaseSuccess: state.useCaseBuilder.isUpdateUseCaseSuccess,
    isRemoveUseCaseSuccess: state.useCaseBuilder.isRemoveUseCaseSuccess,
    searchItem: state.useCaseBuilder.searchItem,
    useCaseDataPageNumber: state.useCaseBuilder.useCaseDataPageNumber,
    useCaseDataTotalRowCount: state.useCaseBuilder.useCaseDataTotalRowCount,
    isAddCustomJsonTemplateSuccess: state.useCaseBuilder.isAddCustomJsonTemplateSuccess,
    isUpdateCustomJsonTemplateSuccess: state.useCaseBuilder.isUpdateCustomJsonTemplateSuccess,
    isDeleteCustomJsonTemplateSuccess: state.useCaseBuilder.isDeleteCustomJsonTemplateSuccess,
    customJsonTemplateTotalRowCount: state.useCaseBuilder.customJsonTemplateTotalRowCount,
    customJsonTemplatePageNumber: state.useCaseBuilder.customJsonTemplatePageNumber,
    isApproveUseCaseSuccess: state.useCaseBuilder.isApproveUseCaseSuccess,
    isApproveUseCaseError: state.useCaseBuilder.isApproveUseCaseError,
    customJsonTemplates: state.useCaseBuilder.customJsonTemplates,
    assets: state.connectivityDashboard.assets,
    assetsLoading: state.connectivityDashboard.assetsLoading,
    userRole: state.userRole.userRole,
    isUserRoleLoading: state.userRole.isUserRoleLoading,
    grafanaTemplateData: state.useCaseBuilder.grafanaTemplateData,
    assetPropertiesData: state.connectivityDashboard.assetPropertiesData,
    assetsPropertiesLoading: state.connectivityDashboard.assetsPropertiesLoading,
    assetsRequestFailed: state.connectivityDashboard.assetsRequestFailed,
    assetsPropertiesRequestFailed: state.connectivityDashboard.assetsPropertiesRequestFailed,
    isGrafanaTemplateError: state.useCaseBuilder.isGrafanaTemplateError,
    isGrafanaTemplateLoading: state.useCaseBuilder.isGrafanaTemplateLoading,
    isForcedDelete: state.useCaseBuilder.isForcedDelete,
});

export default connect(mapStateToProps)(UseCaseBuilder);

